import { axiosCall } from "./apiRequest";
import { baseUrl } from "./helper";



export const getOverviewData = async () => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "vendor/invoice-overview",
      "get",
      "",
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCompanyList = async () => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "invoice/get-company-list",
      "get",
      "",
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getVendorList = async () => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "vendor/vendors-list",
      "get",
      "",
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};


export const getListData = async (data) => {
  try {
    const token = localStorage.getItem("token")
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(baseUrl + "vendor/invoice-list", "post", data, header);
    return response;
  } catch (error) {
    throw error;
  }
};
